module.exports = __webpack_public_path__ + "static/media/hisopado_pos.e10a510a.svg";